"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Object.freeze({
    IOS: 'iOS',
    ANDROID: 'Android',
    WEB: 'web'
});
